import { MessageCircle, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";

interface LessonDiscussionProps {
  lessonId: string;
}

interface MockComment {
  id: number;
  username: string;
  timestamp: string;
  text: { en: string; es: string };
  upvotes: number;
}

const MOCK_COMMENTS: MockComment[] = [
  {
    id: 1,
    username: "PokerPro23",
    timestamp: "2h",
    text: {
      en: "This lesson really helped me understand position play better!",
      es: "Esta leccion me ayudo mucho a entender mejor el juego posicional!",
    },
    upvotes: 12,
  },
  {
    id: 2,
    username: "AceHunter",
    timestamp: "5h",
    text: {
      en: "The simulation part was super useful. I keep replaying it.",
      es: "La parte de simulacion fue super util. La sigo repitiendo.",
    },
    upvotes: 8,
  },
  {
    id: 3,
    username: "BluffMaster",
    timestamp: "1d",
    text: {
      en: "Great explanation! Would love more examples like this.",
      es: "Gran explicacion! Me encantaria mas ejemplos como este.",
    },
    upvotes: 5,
  },
];

export const LessonDiscussion = ({ lessonId: _lessonId }: LessonDiscussionProps) => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.split("-")[0];

  return (
    <div className="w-full max-w-md space-y-4">
      {/* Header */}
      <div className="flex items-center gap-2">
        <MessageCircle className="w-5 h-5 text-primary" />
        <h3 className="font-semibold text-sm">{t("discussion_title")}</h3>
      </div>

      {/* Coming soon banner */}
      <div className="glass border-primary/20 px-3 py-2 text-center">
        <p className="text-xs text-muted-foreground">
          {t("discussion_coming_soon")}
        </p>
      </div>

      {/* Mock comments */}
      <div className="space-y-3">
        {MOCK_COMMENTS.map((comment) => (
          <div key={comment.id} className="glass p-3 space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <div className="w-6 h-6 rounded-full bg-primary/20 flex items-center justify-center">
                  <span className="text-[10px] font-bold text-primary">
                    {comment.username.substring(0, 2).toUpperCase()}
                  </span>
                </div>
                <span className="text-xs font-semibold">{comment.username}</span>
              </div>
              <span className="text-[10px] text-muted-foreground">
                {comment.timestamp}
              </span>
            </div>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {lang === "es" ? comment.text.es : comment.text.en}
            </p>
            <button
              className="flex items-center gap-1 text-muted-foreground hover:text-destructive transition-colors"
              onClick={() => {}}
            >
              <Heart className="w-3.5 h-3.5" />
              <span className="text-[10px]">{comment.upvotes}</span>
            </button>
          </div>
        ))}
      </div>

      {/* Disabled comment input */}
      <div className="relative group">
        <input
          type="text"
          disabled
          placeholder={
            lang === "es" ? "Escribe un comentario..." : "Write a comment..."
          }
          className="w-full glass px-3 py-2.5 text-xs text-muted-foreground cursor-not-allowed opacity-50 rounded-lg"
        />
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="text-[10px] bg-background/90 px-2 py-1 rounded text-muted-foreground">
            Coming soon
          </span>
        </div>
      </div>
    </div>
  );
};
